import { styled } from '@mui/material';
import { useMemo } from 'react';
import { breakpoints, DisplayCard } from 'src/ui-components';

import { salesOverviewRow } from '../../helpers/const';
import { useGetHideMetrics } from '../../hooks/useGetHideMetrics';
import { BlockData } from './components/BlockData';

export const SalesOverview = () => {
  const { hideMetrics } = useGetHideMetrics();

  const metrics = useMemo(
    () => salesOverviewRow.filter((m) => !hideMetrics[m.field]),
    [hideMetrics],
  );

  return (
    <DisplayCardStyled>
      <Wrapper>
        {metrics.map((item, i) => (
          <BlockData {...item} key={i} />
        ))}
      </Wrapper>
    </DisplayCardStyled>
  );
};

const DisplayCardStyled = styled(DisplayCard)`
  height: fit-content;

  ${breakpoints.before.desktop} {
    width: 100%;
  }
`;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  min-width: 200px;
`;
